<template>
    <div>
      <div class="modal hide fade" id="modalTaxSaldo" tabindex="-1" role="dialog" aria-labelledby="modalTaxSaldo" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Tax Saldo</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <form>
                          <div class="form-group">
                            <label for="tax_saldo" class="col-form-label">Date</label>
                            <datetime v-model="taxSaldo.tax_date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta"></datetime>
                          </div>
                          <div class="form-group">
                            <label for="tax_saldo" class="col-form-label">DPP</label>
                            <input v-model="taxSaldo.tax_saldo" type="text" v-money="money" class="form-control"/>
                          </div>
                          <div class="form-group">
                            <label for="tax_saldo" class="col-form-label">Tax Saldo</label>
                            <input v-model="taxSaldo.tax_saldo" type="text" v-money="money" class="form-control"/>
                          </div>
                          <div class="form-group">
                            <label for="company_no" class="col-form-label">Company</label>
                            <select v-model="taxSaldo.company_no" class="form-control">
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label for="notes" class="col-form-label">Notes</label>
                            <textarea v-model="taxSaldo.notes" class="form-control" rows="5"></textarea>
                          </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="save">Save</button>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal hide fade" id="modalTaxSaldoList" tabindex="-1" role="dialog" aria-labelledby="modalTaxSaldoList" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered model-l" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Tax Saldo List</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                    <div class="table-responsive">
                      <table class="table table-item mb-0 table-sm table-striped table-hover">
                        <thead>
                          <th>Date</th>
                          <th class="text-right">DPP</th>
                          <th class="text-right">Saldo</th>
                          <th>Notes</th>
                          <th>#</th>
                        </thead>
                        <tbody>
                          <tr v-for="c in taxSaldoList" :key="c.id">
                            <td>{{ c.tax_date }}</td>
                            <td class="text-right">{{ c.dpp | currency }}</td>
                            <td class="text-right">{{ c.tax_saldo | currency }}</td>
                            <td>{{ c.notes }}</td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="save">Save</button>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, taxUrl } from '../../config'
export default {
  name: 'TaxSaldoModal',
  computed: {
    ...mapState({
      taxSaldoList: state => state.taxes.taxSaldoList,
      companyList: state => state.companies.companyList
    })
  },
  data () {
    return {
      taxSaldo: {
        id: null,
        tax_date: null,
        tax_saldo: '0',
        company_no: null,
        notes: null,
        dpp: '0'
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    async save () {
      this.$emit('saveTaxSaldo', this.taxSaldo)
      await axios.post(taxUrl + '/saldo', this.taxSaldo, { headers: getHeader() })
        .then(response => {
          this.$swal('Success', response.data.message, 'success')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
